// extracted by css-extract-rspack-plugin
export default {"FieldTypeIcon":"XlZ11","ellipsis":"VpvwS"};